import React from 'react';
import ManualReviewCaseDetailSection from '../../../sections/AdminDashboard/Moderation/ManualReviewCaseDetail';

const AdminManualReviewCaseDetail = () => {
  return <ManualReviewCaseDetailSection />;
};

export default AdminManualReviewCaseDetail;

